import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorBannerConfig, ErrorBannerService } from '../../services/error-banner.service';
import { getSupportEmail } from '../../shared/utils/support-email';

@Component({
  standalone: false,
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
})
export class ErrorBannerComponent implements OnInit, OnDestroy {
  showBanner = false;

  private subscription: Subscription;

  constructor(private errorBannerService: ErrorBannerService) {}

  get supportEmail(): string {
    return getSupportEmail();
  }

  ngOnInit(): void {
    this.subscription = this.errorBannerService.banner$.subscribe((config: ErrorBannerConfig) => {
      this.showBanner = config.show;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onRefreshClick(): void {
    this.errorBannerService.refreshPage();
  }
}
